















import VueOptions from '@utils/VueOptions'
import SpaceCreateWizard from '@ui/SpaceWizards/SpaceCreateWizard/SpaceCreateWizard'

settings =
  name: 'SpaceCreate'
  components: { SpaceCreateWizard }

  resources:
    suppliers:
      resourceName: 'supplier'
      slug: 'suppliers'
      limit: 1000

  vue:
    data: ->
      supplierId: @$route.query?.supplierId

    computed:
      optionsForWizard: ->
        supplierId: @supplierId

export default VueOptions.vue settings
